import * as loading from "loading.js";
import * as flashboard from "flashboard_functions.js";
import queryString from 'query-string';

$(function() {
	window.interval_check_caller = false;
	window.interval_check_caller_paused = false;

	/*window.caller_voice = new Audio();
	window.audio_enabled = ! $( '#board-voice' ).hasClass('hide') && (
		localStorage.getItem('flashboard-audio-enabled') === null || parseInt( localStorage.getItem('flashboard-audio-enabled') ) === 1
	);

	if( parseInt( localStorage.getItem('flashboard-audio-enabled') ) === 1 && window.caller_voice.src == '' ) {
		window.caller_voice.play();
	}*/

	// On va regarder si on a un caller actif
	if( $( '.active-caller-container' ).length > 0 ) {

		if( ! $( '.active-caller-container' ).hasClass('raydiant-board') ) {
			detectOrientation( window.matchMedia("(orientation: portrait)").matches );

			window.matchMedia('(orientation: portrait)').addListener(function (m) {
				detectOrientation(m.matches);
			});
		}

		window.interval_check_caller = setInterval( function(){
			// console.log( 'paused : ' + window.interval_check_caller_paused );
			if( window.interval_check_caller_paused === false ) {
				flashboard.refresh_caller();
			}
		}, 1000 );

		// Si on a des valeurs, on va s'assurer que le tableau est positionner au bon endroit
		let current_active_span = $('#drawTable .lastPick');

		if( current_active_span.length > 0 ) {
			$( '#drawTable' ).parent().animate({
				scrollLeft: current_active_span.closest('td').position().left - 45,
				scrollTop: current_active_span.closest('td').position().top + 45
			}, 150);
		}

		setTimeout( function() {
			let activeCallerDiv = $('#active-caller'),
				callerContainer = activeCallerDiv.find('.caller');
		}, 50 );
	}

	if( $( '.flashboard-access-form' ).length > 0 ) {
		$('#alias').focus();

		if( $('#start-webex').length > 0 ) {
			// Create a new Webex app instance
			var app = new window.Webex.Application();

			// Wait for onReady() promise to fulfill before using framework
			app.onReady().then(() => {
				$('#start-webex').click(function(e) {
					e.preventDefault();

					// log( "Info : ", "Click on the button" );

					$.ajax({
						type: 'post',
						url: rootURL + 'flashboard/check-alias-validity/',
						dataType: 'json',
						crossDomain: true,
						async: true,
						cache: false,
						data: $(this).closest('form').serialize(),
						complete: function( json ) {

							// log( "Info :", "AJAX call complete" );
							// log( "Info :", json.responseJSON.result );

							if( json.responseJSON.result === 'success' ) {
								$( '#js-error' ).hide(150).text('');

								// log( "Info :", json.responseJSON.board );
								// log( "Info :", json.responseJSON.boardTitle );

								app.setShareUrl( json.responseJSON.board, "", json.responseJSON.boardTitle ).then(() => {
									// log( "Set share URL", json.responseJSON.board );
									window.location.href = json.responseJSON.board;
								})/*.catch( ( errorcode ) => {
									log( "Error: ", Webex.Application.ErrorCodes[errorcode] )
								});*/
							} else {
								$( '#js-error' ).text( json.responseJSON.message ).show(150);
							}
						}
					});

				});
			})/*.catch((errorcode) =>  {
				// log( "Error with code: ", Webex.Application.ErrorCodes[errorcode] )
			});*/


		} else {
			$('#start-classic').click(function(e) {
				e.preventDefault();

				$(this).closest('form').submit()
			});
		}
	}

});

// Utility function to log app messages
function log(type, data) {
	var ul = document.getElementById("console");
	var li = document.createElement("li");
	var payload = document.createTextNode(`${type}: ${JSON.stringify(data)}`);
	li.appendChild(payload)
	ul.prepend(li);
}

function detectOrientation( hasChanged ) {
	let currentURI = window.location.search,
		parsedURI = queryString.parse( window.location.search ),
		portrait = window.matchMedia("(orientation: portrait)"),
		orientation = ( portrait.matches ? 'portrait' : 'landscape' );

	if( hasChanged === undefined || parsedURI.orientation !== orientation ) {
		parsedURI.orientation = orientation;
		redirectURIParams = queryString.stringify( parsedURI );

		window.location = location.protocol + '//' + location.host + location.pathname + ( redirectURIParams != '' ? '?' + redirectURIParams : '' );
	}
}